module.exports = __webpack_public_path__ + "static/media/gb-eng.e6275edd.svg";